var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M2,0H16a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V12H2v4H16V2H2V6H0V2A2,2,0,0,1,2,0ZM8.5,14,7.09,12.59,9.67,10H0V8H9.67L7.09,5.41,8.5,4l5,5Z","fill":"#a6aab4"}})}
var staticRenderFns = []

export { render, staticRenderFns }